import React, { useState, useContext } from 'react';

import { withTheme } from 'styled-components';

import { toast } from 'react-toastify';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Row, Col } from 'react-bootstrap';
import { faSpinner, faStar } from '@fortawesome/free-solid-svg-icons';
import { faThumbsUp, faThumbsDown } from '@fortawesome/free-regular-svg-icons';

import {
  Button,
  Field,
  Label,
  Modal,
  TextArea,
} from '@cloudez/cloudez-design-system';
import {
  Header,
  Icon,
  Text,
  Title,
  Subtitle,
  Content,
  Footer,
} from 'components/ListingModal/styles';

import { useAuth } from 'hooks/auth';

import { Selection, Select } from '../../TicketDetail/RatingModal/styles';

import { TicketListingContext } from '../_context/state';
import { set } from 'react-ga';

const RatingModal = ({ show, setShow, ticket }) => {
  const { updateTicket } = useContext(TicketListingContext);

  const [loading, setLoading] = useState(false);

  const [_ticket] = useState(ticket);
  const [rating, setRating] = useState(ticket.rating);
  const [ratingComment, setRatingComment] = useState(ticket?.rating_comment);
  const { user } = useAuth();

  const closeTicket = async () => {
    setLoading(true);
    try {
      const data = await updateTicket(null, null, _ticket.id, {
        status: 2,
        rating,
        rating_comment: ratingComment,
      });
      if (!data) throw new Error();
      setLoading(false);
      setShow(false);
    } catch (e) {
      setLoading(false);

      toast.error('Não foi possível fechar o ticket.');
    }
  };

  const rateTicket = async () => {
    setLoading(true);
    try {
      if (
        user.email === ticket.owner_email ||
        user.roles.includes('team_leader_role')
      ) {
        const data = await updateTicket(null, null, _ticket.id, {
          rating,
          rating_comment: ratingComment,
        });
        if (!data) throw new Error();
        setLoading(false);
        setShow(false);
      } else {
        setLoading(false);
        setShow(false);
        toast.error('Você não tem permissão para avaliar esse ticket.');
      }
    } catch (e) {
      setLoading(false);

      toast.error('Não foi possível avaliar o ticket.');
    }
  };

  return (
    <Modal show={show} setShow={setShow} noExit={loading}>
      <Header>
        <Icon>
          <FontAwesomeIcon icon={faStar} />
        </Icon>
        <Text>
          <Title>Avalie o atendimento</Title>
          <Subtitle>Como foi sua experiência nesse ticket?</Subtitle>
        </Text>
      </Header>

      <Content>
        <Row>
          <Col>
            <Label>Você foi bem atendido?</Label>
            <Selection>
              <Select selected={rating === 1} onClick={() => setRating(1)}>
                <FontAwesomeIcon className="green" icon={faThumbsUp} />
              </Select>
              <Select selected={rating === 2} onClick={() => setRating(2)}>
                <FontAwesomeIcon className="red" icon={faThumbsDown} />
              </Select>
            </Selection>
          </Col>
        </Row>
        <Row>
          <Col>
            <Field>
              <Label>Sua solicitação foi resolvida? Deixe um comentário</Label>
              <TextArea
                block
                height="100px"
                value={ratingComment}
                onChange={e => setRatingComment(e.target.value)}
              />
            </Field>
          </Col>
        </Row>
      </Content>
      <Footer>
        <Button
          icon
          onClick={
            ticket.rating === 1 || ticket.rating === 2
              ? rateTicket
              : closeTicket
          }
          disabled={loading || !rating}
        >
          {loading ? (
            <FontAwesomeIcon icon={faSpinner} spin />
          ) : ticket.rating === 1 || ticket.rating === 2 ? (
            'Avaliar ticket'
          ) : (
            'Fechar ticket'
          )}
        </Button>
      </Footer>
    </Modal>
  );
};

export default withTheme(RatingModal as any);
